import DescItem from '../desc/description-item'

DescItem.install = (app) => {
  app.component(DescItem.name, DescItem)
}
export default DescItem
